/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FanRemixContestWinnersSelectedNotificationActionData
 */
export interface FanRemixContestWinnersSelectedNotificationActionData {
    /**
     * 
     * @type {string}
     * @memberof FanRemixContestWinnersSelectedNotificationActionData
     */
    entityUserId: string;
    /**
     * 
     * @type {string}
     * @memberof FanRemixContestWinnersSelectedNotificationActionData
     */
    entityId: string;
}

/**
 * Check if a given object implements the FanRemixContestWinnersSelectedNotificationActionData interface.
 */
export function instanceOfFanRemixContestWinnersSelectedNotificationActionData(value: object): value is FanRemixContestWinnersSelectedNotificationActionData {
    let isInstance = true;
    isInstance = isInstance && "entityUserId" in value && value["entityUserId"] !== undefined;
    isInstance = isInstance && "entityId" in value && value["entityId"] !== undefined;

    return isInstance;
}

export function FanRemixContestWinnersSelectedNotificationActionDataFromJSON(json: any): FanRemixContestWinnersSelectedNotificationActionData {
    return FanRemixContestWinnersSelectedNotificationActionDataFromJSONTyped(json, false);
}

export function FanRemixContestWinnersSelectedNotificationActionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FanRemixContestWinnersSelectedNotificationActionData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entityUserId': json['entity_user_id'],
        'entityId': json['entity_id'],
    };
}

export function FanRemixContestWinnersSelectedNotificationActionDataToJSON(value?: FanRemixContestWinnersSelectedNotificationActionData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entity_user_id': value.entityUserId,
        'entity_id': value.entityId,
    };
}

